import TestStep from '@qality/common-model/src/TestStep';
import TestStepsCollection from '@qality/common-model/src/TestStepsCollection';
import { StorageOfUniqueServices } from '@qality/common-service';

export const getAttachmentsIdsList = (
  stepToBeDeletedId: number,
  testStepsCollection: TestStepsCollection
): Array<number> => {
  let attachmentsIds = [];

  testStepsCollection?.testSteps.forEach((testStep) => {
    if (testStep.id === stepToBeDeletedId) {
      return;
    }
    attachmentsIds = attachmentsIds.concat(
      testStep.attachments.map((attachment) => attachment.id)
    );
  });

  return attachmentsIds;
};

export const deleteTestStepAttachments = (
  testStep: TestStep,
  testStepsCollection: TestStepsCollection
): void => {
  if (!testStep) {
    // new steps do not save attachments on upload.
    // They do it on save step click.
    // No need to do anything then.
    return;
  }
  const attachmentsIds = getAttachmentsIdsList(
    testStep.id,
    testStepsCollection
  );
  testStep.attachments.forEach((attachment) => {
    if (attachmentsIds.includes(attachment.id)) {
      // since other steps have this attachment do not delete it.
      return;
    }
    StorageOfUniqueServices.get('AttachmentService').deleteAttachment(
      attachment.id
    );
  });
};
